(function () {
  function parseVariantsFromNode(node) {
    if (!node) return [];

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.warn('Dotty variant price hints: could not parse variants', error);
      return [];
    }
  }

  function getProductInfo(container) {
    return container?.closest('product-info') || null;
  }

  function cacheVariants(productInfo, variants) {
    if (!productInfo || !variants.length) return;
    productInfo.dataset.dottyVariants = JSON.stringify(variants);
  }

  function getVariants(container) {
    const productInfo = getProductInfo(container);
    const inlineNode = container.querySelector('[data-dotty-variants]');

    if (inlineNode) {
      const variants = parseVariantsFromNode(inlineNode);
      cacheVariants(productInfo, variants);
      return variants;
    }

    if (!productInfo?.dataset.dottyVariants) return [];

    try {
      return JSON.parse(productInfo.dataset.dottyVariants);
    } catch {
      return [];
    }
  }

  function parseHintOptions(container) {
    try {
      return JSON.parse(container.dataset.hintOptions || '[]');
    } catch {
      return [];
    }
  }

  function getVariantSelects(productInfo) {
    return productInfo?.querySelector('variant-selects') || null;
  }

  function getSelections(container) {
    const selections = {};

    container.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      if (input.dataset.optionName) {
        selections[input.dataset.optionName] = input.value;
      }
    });

    const select = container.querySelector('select');
    if (select?.selectedOptions?.[0]?.dataset.optionName) {
      const option = select.selectedOptions[0];
      selections[option.dataset.optionName] = option.value;
    }

    return selections;
  }

  function findVariant(variants, selections) {
    return variants.find((variant) =>
      Object.entries(variant.options).every(([name, value]) => selections[name] === value)
    );
  }

  function createMoneyFormatter(container) {
    const currency = container.dataset.currencyCode || 'GBP';
    const sample = getProductInfo(container)?.querySelector('.price-item--regular')?.textContent?.trim() || '';
    const includeCurrencyCode = /\b(GBP|USD|EUR)\b/.test(sample);

    return (cents) => {
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);

      return includeCurrencyCode ? `${formatted} ${currency}` : formatted;
    };
  }

  function formatDelta(cents, currency) {
    if (!cents) return '';

    const amount = Math.round(Math.abs(cents) / 100);
    const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: currency || 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
    const sign = cents > 0 ? '+' : '−';
    return `(${sign}${formatted})`;
  }

  function setDelta(deltaEl, deltaCents, currency) {
    if (!deltaEl) return;

    if (!deltaCents) {
      deltaEl.textContent = '';
      deltaEl.hidden = true;
      return;
    }

    deltaEl.textContent = formatDelta(deltaCents, currency);
    deltaEl.hidden = false;
  }

  function updateMainPrice(container, variant) {
    const productInfo = getProductInfo(container);
    if (!productInfo || !variant) return;

    const priceRoot = productInfo.querySelector(`#price-${productInfo.dataset.section}`);
    if (!priceRoot) return;

    priceRoot.classList.remove('hidden');

    const formatMoney = createMoneyFormatter(container);
    const formattedPrice = formatMoney(variant.price);
    const regularPrice = priceRoot.querySelector('.price__regular .price-item--regular');
    const salePrice = priceRoot.querySelector('.price__sale .price-item--sale');

    if (regularPrice) regularPrice.textContent = formattedPrice;
    if (salePrice) salePrice.textContent = formattedPrice;

    container.dataset.selectedPriceAmount = (variant.price / 100).toFixed(2);
  }

  function updateHints(container) {
    const variants = getVariants(container);
    if (!variants.length) return;

    const hintOptions = parseHintOptions(container);
    const currency = container.dataset.currencyCode || 'GBP';
    const selections = getSelections(container);
    const currentVariant = findVariant(variants, selections);

    if (!currentVariant) return;

    updateMainPrice(container, currentVariant);

    if (!hintOptions.length) return;

    hintOptions.forEach((optionName) => {
      container.querySelectorAll(`input[type="radio"][data-option-name="${optionName}"]`).forEach((input) => {
        const testSelections = { ...selections, [optionName]: input.value };
        const variant = findVariant(variants, testSelections);
        const deltaEl = input.nextElementSibling?.querySelector('.dotty-variant-option__delta');

        if (!variant) {
          setDelta(deltaEl, 0, currency);
          return;
        }

        setDelta(deltaEl, variant.price - currentVariant.price, currency);
      });
    });
  }

  function initProductInfo(productInfo) {
    if (!productInfo?.classList.contains('luxe-dotty-pdp') && !productInfo?.querySelector('.luxe-dotty-pdp__eyebrow')) {
      return;
    }

    const container = getVariantSelects(productInfo);
    if (!container) return;

    getVariants(container);
    updateHints(container);
  }

  function initWithin(root) {
    root.querySelectorAll('product-info').forEach(initProductInfo);
  }

  function handleVariantSelectChange(event) {
    const container = event.target.closest('variant-selects');
    const productInfo = getProductInfo(container);

    if (!productInfo || !productInfo.querySelector('.luxe-dotty-pdp__eyebrow')) return;

    updateHints(container);
  }

  document.addEventListener('DOMContentLoaded', () => initWithin(document));

  document.addEventListener('product-info:loaded', (event) => {
    initWithin(event.target);
  });

  document.addEventListener('change', handleVariantSelectChange, true);

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data?.sectionId) return;

      const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      const container = getVariantSelects(productInfo);
      if (!container) return;

      window.requestAnimationFrame(() => updateHints(container));
    });
  }
})();
